import { useSelector, useDispatch } from "react-redux"
import { sanitizeInnerHtml, toggeleBodyClass } from "@/utils/helper"
import React, { useEffect, useRef } from "react"
import { isMobile } from "react-device-detect"
import { getUserMenuFragmentEventInfo } from "@/components/Default/AuthUtilityNav/v1/MegaMenu/analytics"
import {
  selectGenericState,
  closeMenu,
  openMenu,
} from "@/store/features/genericSlice"
import useWindowDimensions from "@/hooks/useWindowDimensions"

// const isMobile =
//   window.outerWidth === 0
//     ? window.innerWidth <= 1200
//     : isSafari
//     ? window.innerWidth <= 1200
//     : window.outerWidth <= 1200

const MegaMenu = props => {
  const {
    userMenuFragment,
    guestMenuFragment,
    isLoggedIn,
    i18n,
    user,
    logout,
    toggleAuthNav,
    handleSignin,
    handleCreateAccount,
    onAuthMenuClick,
  } = props
  const dispatch = useDispatch()
  const { winWidth } = useWindowDimensions()
  const {
    menu: { isOpen },
  } = useSelector(selectGenericState)

  const signOutEventInfo = JSON.stringify({
    eventName: "my account:sign out",
    eventAction: "my account:sign out",
    internalLinkName: "sign out",
    internalLinkType: "global header:navigation",
    internalLinkZoneName: "global header",
    clickInternalLinks: "true",
    eventType: "navigation",
    internalLinkURL: window.location.origin + "/en",
    internalLinkPosition: "global header sign out",
    eventMsg: "n/a",
    eventStatus: "n/a",
  })

  const leftArrow = "/icons/left-arrow-white.svg"
  const iconCloseMedium = "/icons/close-medium.svg"
  const iconUserSignin = "/icons/user-signin.svg"
  const name = user && user?.firstName
  const modalWindow = useRef(null)

  const handleKeyPress = () => {
    if (userMenuFragment) {
      addAnalyticsUserMenuFragment()
    }
  }

  useEffect(() => {
    window.addEventListener("click", handleKeyPress)

    modalWindow.current.focus()
    if (userMenuFragment) {
      addAnalyticsUserMenuFragment()
    }
    return () => {
      window.removeEventListener("click", handleKeyPress)
    }
  })

  const addAnalyticsUserMenuFragment = () => {
    setTimeout(() => {
      modalWindow.current.querySelectorAll("p a").forEach(link => {
        link.classList.add("gbh-data-layer")
        const textContent =
          link?.textContent ||
          (link.querySelector("u") ? link.querySelector("u").textContent : "")
        const eventInfo = getUserMenuFragmentEventInfo(
          textContent?.toLowerCase(),
          themeChange,
          link?.href
        )
        link.setAttribute("data-gbh-data-layer", eventInfo)
      })
    })
  }

  const capitalizeFirstName = firstname => {
    firstname = firstname?.charAt(0).toUpperCase() + firstname?.slice(1)
    return firstname
  }
  const toggleMenu = () => {
    if (isOpen) {
      dispatch(closeMenu())
    } else {
      dispatch(openMenu())
    }
  }
  const themeChange =
    typeof window !== "undefined" &&
    winWidth <= 1200 &&
    (document.body.classList.contains("nav-light-theme") ||
      document.body.classList.contains("nav-dark-theme"))

  return (
    <div className="container kf-react-container">
      {isMobile && isLoggedIn && (
        <div
          tabIndex="0"
          role="button"
          id="auth-nav__menu-mobile-back"
          className="auth-nav__menu-mobile-back-menu"
          onClick={() => {
            toggleAuthNav()
            onAuthMenuClick(false)
            toggeleBodyClass(false)
          }}
        >
          {themeChange ? null : <img src={leftArrow} alt={i18n.leftArrowAlt} />}

          {themeChange ? (
            <span>{`${i18n.hi} ${capitalizeFirstName(user?.firstName)}`}</span>
          ) : (
            <span>{`${i18n.menu}`}</span>
          )}

          {themeChange ? (
            <span
              className="gbh-hamber-menu gbh-close icon-Close-Medium"
              aria-label="close button"
              tabIndex="0"
              onClick={() => {
                toggleMenu()
              }}
            >
              <img src={iconCloseMedium} alt="" />
            </span>
          ) : null}
        </div>
      )}
      <div id="auth-nav__menu-wrap" className="auth-nav__menu-wrap">
        <div className="auth-nav__menu-title">
          {isLoggedIn ? `${i18n.welcome} ${name}!` : i18n.title}
        </div>
        <div className="auth-nav__menu-items" role="list">
          {!isLoggedIn && (
            <span role="list-item">
              <a
                role="button"
                name="signin"
                id="kf-react-sign-in"
                onClick={handleSignin}
                className="gbh-data-layer"
              >
                {themeChange ? <img src={iconUserSignin} alt="" /> : null}
                {i18n.signIn}
              </a>
              <br />
            </span>
          )}
          {!isLoggedIn && (
            <span role="list-item">
              <a
                role="button"
                className="gbh-data-layer"
                id="kf-react-sign-up"
                name="create-account"
                onClick={handleCreateAccount}
              >
                {themeChange ? <img src={iconUserSignin} alt="" /> : null}
                {i18n.createAccount}
              </a>
              <br />
            </span>
          )}
          <div
            role="list-item"
            data-gbh-data-layer={addAnalyticsUserMenuFragment}
            ref={modalWindow}
            onClick={handleKeyPress}
            className="order-status-signin"
          >
            {sanitizeInnerHtml(
              isLoggedIn ? userMenuFragment : guestMenuFragment ?? null
            )}
          </div>
          {isLoggedIn && (
            <span className="sign-out">
              <a
                role="button"
                onClick={logout}
                className="gbh-data-layer"
                data-gbh-data-layer={signOutEventInfo}
              >
                {i18n.logout}
              </a>
              <br />
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default MegaMenu
